<template>
  <el-dialog
    class="new-dailog"
    :class="{ 'no-header': !showHead }"
    v-bind="dialogProps"
    @update:visible="$emit('update:visible', $event)"
    @closed="onClosed"
  >
    <slot />
    <template v-if="showFooter" #footer>
      <el-button size="small" @click="$emit('update:visible', false)"
        >取消</el-button
      >
      <el-button size="small" type="primary" @click="onConfirm">确定</el-button>
    </template>
  </el-dialog>
</template>
<script>
import { pick } from "@/utils/helpers.js";

const DIALOG_PROPS = {
  visible: Boolean,
  title: {
    type: String,
    default: ""
  },
  modalAppendToBody: {
    type: Boolean,
    default: true
  },

  appendToBody: {
    type: Boolean,
    default: false
  },

  lockScroll: {
    type: Boolean,
    default: true
  },

  closeOnClickModal: {
    type: Boolean,
    default: true
  },

  closeOnPressEscape: {
    type: Boolean,
    default: true
  },

  showClose: {
    type: Boolean,
    default: true
  },

  width: String,

  fullscreen: Boolean,

  customClass: {
    type: String,
    default: ""
  },

  top: {
    type: String,
    default: "15vh"
  },
  beforeClose: Function,
  center: {
    type: Boolean,
    default: false
  },
  destroyOnClose: Boolean,
  showFooter: {
    type: Boolean,
    default: true
  },
  showHead: {
    type: Boolean,
    default: true
  }
};

export default {
  name: "NewDialog",
  props: {
    ...DIALOG_PROPS
  },
  computed: {
    dialogProps() {
      return pick(this, Object.keys(DIALOG_PROPS));
    }
  },
  methods: {
    onClosed() {
      this.$emit("cancelFun");
    },
    onConfirm() {
      this.$emit("submitFun");
    }
  }
};
</script>
<style lang="scss">

.new-dailog {
  .el-dialog__title {
    font-size: 16px;
  }
  .el-dialog__body {
    padding: 20px !important;
  }
}
.no-header {
  .el-dialog__header,
  .el-dialog__body {
    padding: 0 !important;
  }
}

</style>
